import { useTranslation } from '@exam-room/translations';

import { Button, Modal } from '../../../../components';

export default function StartExamErrorModal({
  show,
  onClose,
  variant,
}: {
  show: boolean;
  onClose: () => void;
  variant: 'not-in-exam-time' | 'system-error';
}) {
  const { t } = useTranslation();

  return (
    <Modal open={show} className='grid max-w-lg gap-6'>
      <h3>
        {variant === 'not-in-exam-time'
          ? t('startExamErrorModal.NotInExamTime.title')
          : t('startExamErrorModal.SystemError.title')}
      </h3>
      <div>
        {variant === 'not-in-exam-time' ? (
          <>
            <p>{t('startExamErrorModal.NotInExamTime.description.1')}</p>
            <p>{t('startExamErrorModal.NotInExamTime.description.2')}</p>
          </>
        ) : (
          <>
            <p>{t('startExamErrorModal.SystemError.description.1')}</p>
            <p>{t('startExamErrorModal.SystemError.description.2')}</p>
          </>
        )}
      </div>
      {variant === 'system-error' ? (
        <p className='font-normal'>{t('startExamErrorModal.SystemError.description.3')}</p>
      ) : null}
      <div className='flex justify-end gap-3'>
        <Button className='text-black' onClick={onClose}>
          {variant === 'not-in-exam-time' ? t('acknowledge') : t('retry')}
        </Button>
      </div>
    </Modal>
  );
}
